export enum ProjectType {
	CORE = 'CORE'
}

export enum ProjectFilterType {
	Date = 'date',
	Integer = 'integer',
	String = 'string',
	Status = 'status'
}

export enum ProjectStatus {
	Ongoing = 'ongoing',
	OnHold = 'onhold',
	Ended = 'ended',
	Frozen = 'frozen',
	PendingAdminApproval = 'pendingAdminApproval',
	Rejected = 'rejected'
}

export enum ProjectOwnership {
	Own = 'own',
	SharedWithMe = 'sharedWithMe',
	All = 'all',
	Invitations = 'invitations'
}
